/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetTypeSubsystemComponentclassResponseDto
 */
export interface AssetTypeSubsystemComponentclassResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetTypeSubsystemComponentclassResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetTypeSubsystemComponentclassResponseDto
     */
    assetTypeSubsystemId: string;
    /**
     * Code of the subsystem
     * @type {string}
     * @memberof AssetTypeSubsystemComponentclassResponseDto
     */
    subsystemCode: string;
    /**
     * Code of the asset type
     * @type {string}
     * @memberof AssetTypeSubsystemComponentclassResponseDto
     */
    assetTypeCode: string;
    /**
     * Array of associated component class IDs
     * @type {Array<string>}
     * @memberof AssetTypeSubsystemComponentclassResponseDto
     */
    associatedComponentClassIds: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeSubsystemComponentclassResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetTypeSubsystemComponentclassResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the AssetTypeSubsystemComponentclassResponseDto interface.
 */
export function instanceOfAssetTypeSubsystemComponentclassResponseDto(value: object): value is AssetTypeSubsystemComponentclassResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetTypeSubsystemId' in value) || value['assetTypeSubsystemId'] === undefined) return false;
    if (!('subsystemCode' in value) || value['subsystemCode'] === undefined) return false;
    if (!('assetTypeCode' in value) || value['assetTypeCode'] === undefined) return false;
    if (!('associatedComponentClassIds' in value) || value['associatedComponentClassIds'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function AssetTypeSubsystemComponentclassResponseDtoFromJSON(json: any): AssetTypeSubsystemComponentclassResponseDto {
    return AssetTypeSubsystemComponentclassResponseDtoFromJSONTyped(json, false);
}

export function AssetTypeSubsystemComponentclassResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetTypeSubsystemComponentclassResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetTypeSubsystemId': json['assetTypeSubsystemId'],
        'subsystemCode': json['subsystemCode'],
        'assetTypeCode': json['assetTypeCode'],
        'associatedComponentClassIds': json['associatedComponentClassIds'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function AssetTypeSubsystemComponentclassResponseDtoToJSON(json: any): AssetTypeSubsystemComponentclassResponseDto {
    return AssetTypeSubsystemComponentclassResponseDtoToJSONTyped(json, false);
}

export function AssetTypeSubsystemComponentclassResponseDtoToJSONTyped(value?: AssetTypeSubsystemComponentclassResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetTypeSubsystemId': value['assetTypeSubsystemId'],
        'subsystemCode': value['subsystemCode'],
        'assetTypeCode': value['assetTypeCode'],
        'associatedComponentClassIds': value['associatedComponentClassIds'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

